module.exports = __webpack_public_path__ + "static/media/200633.b4f921fa.jpg";